export default function Title({ text, type }) {
    return (
        <div className="flex-1 min-w-0">
            {type === "head" && <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">{text}</h2>}
            {type === "secondary" && <h2 className="text-xl font-bold leading-7 text-gray-700 sm:text-xl sm:truncate">{text}</h2>}
        </div>
    )
  }